import { Dispatch } from 'react';
import { IAction } from '../context/UseReportableDataContext';
import { DashboardCurrency, DashboardDateRange } from '../entities';
import { getDefaultGranularityForDateRange } from '../utils/mapping';

export function storeCurrenciesAction(dispatch: Dispatch<IAction>, currencies: string[]) {
  dispatch({
    type: 'STORE_CURRENCIES',
    payload: { currencies },
  });
  dispatch({
    type: 'FINISH_LOADING',
  });
}

export function setCurrencyFilterAction(dispatch: Dispatch<IAction>, filterCurrency: DashboardCurrency | null) {
  dispatch({
    type: 'SET_CURRENCY_FILTER',
    payload: { filterCurrency },
  });
  dispatch({
    type: 'UPDATE_QUERYSTRING',
  });
}

export function setDateRangeFilterAction(
  dispatch: Dispatch<IAction>,
  dateRange: DashboardDateRange,
  dateRangeOffset = 0,
) {
  const granularity = getDefaultGranularityForDateRange(dateRange);
  dispatch({
    type: 'SET_DATE_RANGE_FILTER',
    payload: { dateRange, dateRangeOffset, granularity },
  });
  dispatch({
    type: 'UPDATE_DATE_TARGET',
  });
}
